"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HighlightContext = void 0;
var HighlightContext;
(function (HighlightContext) {
    HighlightContext["TITLE"] = "TITLE";
    HighlightContext["SHORT_DESCRIPTION"] = "SHORT_DESCRIPTION";
    HighlightContext["CONTACT_PERSON"] = "CONTACT_PERSON";
    HighlightContext["EMAIL"] = "EMAIL";
    HighlightContext["REFERENCE_NUMBER"] = "REFERENCE_NUMBER";
    HighlightContext["PROCURING_AGENCY"] = "PROCURING_AGENCY";
    HighlightContext["CPVS"] = "CPVS";
    HighlightContext["QUICK_SUMMARY_ENGLISH"] = "QUICK_SUMMARY_ENGLISH";
})(HighlightContext = exports.HighlightContext || (exports.HighlightContext = {}));
